import React from 'react'

import './styles.scss'
import ButtonRounded from 'components/ButtonRounded'

const ButtonGooglePay = props => (
  <ButtonRounded
    icon="google_pay"
    as="button"
    bgClassName="bg--black"
    wrapperClassName="btn--payment"
    iconColor="transparent"
    wrapperProps={props}
  />
)

export default ButtonGooglePay
